import React, {useEffect} from 'react'
import {useQuery} from "react-query";
import {getLessonsById} from "../../../../services/lessonSvc";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {LoaderSection} from "../../../../components/sections/loader/Loader";
import {EmptySection} from "../../../../components/sections/empty/Empty";
import {KTIcon, useDebounce} from "../../../../../_metronic/helpers";
import {separateFormatter} from "../../../../utils/separateFormatter";
import {PageHeader} from "../../../../components/common/pageHeader/PageHeader";
import {Pagination} from "../../../../components/common/pagination/Pagination";
import {LessonCard} from "../../../../components/common/lessonCard/LessonCard";

export const LessonPage = () => {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const page = parseInt(searchParams.get("page") || "1", 10)
  const searchQuery = searchParams.get("search") || ""
  const debouncedSearch = useDebounce(searchQuery, 500);
  const {courseId} = useParams()

  const {
    data: lessonData,
    isLoading: lessonIsLoading,
    isError: lessonIsError,
    refetch: refetchLesson
  } = useQuery(["getLessonById", page, debouncedSearch], () => getLessonsById({
    params: {
      category: Number(courseId),
      page_size: 8,
      page,
      search: debouncedSearch
    }
  }), {
    keepPreviousData: true,
  })


  const pageDetails = {
    title: lessonData?.data?.[0]?.category?.title || "Darslar",
    desc: `Jami darslar soni: (${separateFormatter(lessonData?.total_items || 0, " ", "ta")})`,
    buttons: [{
      onClick: () => navigate(`/courses/${courseId}/lesson/create`),
      text: "Qo'shish",
      icon: "plus-square",
    }]
  };

  const totalItems = lessonData?.total_items || 0;
  const itemsPerPage = lessonData?.page_size || 8;

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchParams({page: "1", search: query});
  }

  useEffect(() => {
    if (debouncedSearch) {
      refetchLesson();
    }
  }, [debouncedSearch, refetchLesson]);


  if (lessonIsLoading) {
    return <LoaderSection height={"50vh"}/>
  }

  if (lessonIsError) {
    return <EmptySection height={"50vh"}/>
  }

  return (
      <div>
        <div className="">
          <PageHeader pageDetails={pageDetails}/>
          <div className={"d-flex flex-wrap justify-content-between align-items-center rounded py-1 mb-5"}>
            <div className={"w-100 w-100 w-md-250px"}>
              <div className="d-flex align-items-center position-relative my-1">
                <KTIcon iconName={"magnifier"} className={"fs-1 position-absolute ms-3"}/>

                <input type="text" data-kt-user-table-filter="search"
                       className="form-control w-100 w-md-250px ps-12"
                       placeholder="Qidiruv..." value={searchQuery}
                       onChange={handleSearchChange}/>
              </div>
            </div>
          </div>

          {lessonIsLoading ? (
              <LoaderSection height={"50vh"}/>
          ) : !lessonData || lessonData.data.length === 0 ? (
              <EmptySection height={"50vh"}/>
          ) : (
              <>
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-1 row-cols-lg-1 row-cols-xl-2 g-6 mb-10">
                  {lessonData.data.map((lessonItem) => (
                      <LessonCard key={lessonItem?.id} refetchLesson={refetchLesson} lesson={lessonItem}/>
                  ))}
                </div>
                <Pagination
                    totalItems={totalItems}
                    itemsPerPage={itemsPerPage}
                />
              </>
          )}
        </div>
      </div>
  )
}
